import { render, staticRenderFns } from "./PublicCollectionScreen.vue?vue&type=template&id=a8532122&"
import script from "./PublicCollectionScreen.vue?vue&type=script&lang=js&"
export * from "./PublicCollectionScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports